import Box from '@mui/material/Box'
import {IconButton} from '@mui/material'
import PropTypes from 'prop-types'
import {StyledClose, StyledSnackbar} from './UseCaseStyles'

export default function UseCaseNotificationAlert({message, vertical, horizontal, open, setOpen}) {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
  }

  return (
    <Box>
      <StyledSnackbar
        autoHideDuration={5000}
        anchorOrigin={{vertical, horizontal}}
        open={open}
        message={message}
        action={
          <IconButton aria-label='close' onClick={handleClose}>
            <StyledClose />
          </IconButton>
        }
        onClose={handleClose}
      />
    </Box>
  )
}

UseCaseNotificationAlert.propTypes = {
  message: PropTypes.node.isRequired,
  vertical: PropTypes.string.isRequired,
  horizontal: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired
}
